// extracted by mini-css-extract-plugin
module.exports = {"gameOverControls":"GameOverContainer_gameOverControls__1AbGo"};